import { hot } from 'react-hot-loader/root';
import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

import { AuthProvider } from '@goeuro/app/client/auth-provider/src/index';
import WhitelabelProvider from '@goeuro/app/client/b2b-components/src/containers/whitelabel-provider';

import { Holder } from './app.styled';
import { useMobileDetect } from 'shared/utils';
import GlobalStyle from 'global.styles';
import { IsMobileContext } from 'contexts/mobile';
import AppRoutes from 'routes';
import { useLazyLocales, useGlobalState } from '../hooks';
import { withField } from '../shared/utils/url';

const App = () => {
  const { locale, currency } = useGlobalState();
  const isMobile = useMobileDetect();

  /* Trigger rerender only when translations have been loaded */
  const { lang, translations } = useLazyLocales(locale);

  useEffect(() => withField(locale, 'locale'), [locale]);
  useEffect(() => withField(currency, 'currency'), [currency]);

  if (!lang) return null;

  return (
    <IntlProvider locale={lang} messages={translations}>
      <AuthProvider>
        <WhitelabelProvider useFullWlConfig>
          <IsMobileContext.Provider value={isMobile}>
            <Router basename="/">
              <GlobalStyle />
              <Holder>
                <AppRoutes translations={translations} />
              </Holder>
            </Router>
          </IsMobileContext.Provider>
        </WhitelabelProvider>
      </AuthProvider>
    </IntlProvider>
  );
};

export default hot(App);
